module.exports = __webpack_public_path__ + "fonts/proximanova-semibold-webfont.ef7bd615.woff";